import {
	RESET_STATE,
	SET_THERMOBOXES_REPORTS,
	SET_IS_THERMOBOXES_REPORTS_LOADING,
	SET_PAGINATION,
	SET_THERMOBOXES,
	SET_IS_THERMOBOXES_LOADING,
	SET_MODES,
	SET_IS_MODES_LOADING,
} from './actions';

export const initialState = {
	thermoboxesReports: [],
	isThermoboxesReportsLoading: false,
	pagination: null,
	modes: [],
	isModesLoading: false,
	thermoboxes: [],
	isThermoboxesLoading: false,
};

const thermoboxesReportsContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_THERMOBOXES_REPORTS:
			return {
				...state,
				thermoboxesReports: payload,
			};
		case SET_IS_THERMOBOXES_REPORTS_LOADING:
			return {
				...state,
				isThermoboxesReportsLoading: payload,
			};
		case SET_THERMOBOXES:
			return { ...state, thermoboxes: payload };
		case SET_IS_THERMOBOXES_LOADING:
			return { ...state, isThermoboxesLoading: payload };
		case SET_MODES:
			return { ...state, modes: payload };
		case SET_IS_MODES_LOADING:
			return { ...state, isModesLoading: payload };
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default thermoboxesReportsContainerReducer;
